module.exports = __webpack_public_path__ + "img/art1-img2.06ad595d.jpeg";